import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Home from './views/Home.vue'
import Login from './views/Login.vue'
import adminPanel from './views/adminPanel.vue'

import Menu from './views/Menu.vue'
import MenuForKids from './views/MenuForKids.vue'
import MenuAlcohols from './views/MenuAlcohols.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/menu',
      name: 'menu',
      component: Menu,
    },
    {
      path: '/dla_dzieci',
      component: MenuForKids,
    },
    {
      path: '/karta_win_i_piw',
      component: MenuAlcohols,
    },
    {
      path: '/login',
      component: Login,
      beforeEnter: (to, from, next) => {
        const currentUser = firebase.auth().currentUser
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

        if (!requiresAuth && currentUser) next ('/adminPanel')
        else next()
      }
    },
    {
      path: '/adminPanel',
      component: adminPanel,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        const currentUser = firebase.auth().currentUser
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

        if (requiresAuth && !currentUser) next ('/login')
        else if (!requiresAuth && currentUser) next ('/adminPanel')
        else next()
      }
    }
  ]
})
